import PropTypes from 'prop-types';
// @mui
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

// components
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function UserTableFiltersResult({
  filters,
  onFilters,
  //
  onResetFilters,
  //
  results,
  ...other
}) {
  const handleRemoveStatus = () => {
    onFilters('status', 'all');
  };

  
  const handleRemoveName = (keyword) => {
    onFilters(keyword, '');
  };
  const handleRemoveRole = () => {
    onFilters('role', 'all');
  };

  const handleRemoveCategory = () => {
    onFilters('category', []);
  };
  const categoryCount = Array.isArray(filters?.category) ? filters.category.length : 0;

  return (
    <Stack spacing={1.5} {...other}>
      <Box sx={{ typography: 'body2' }}>
        <strong>{results}</strong>
        <Box component="span" sx={{ color: 'text.secondary', ml: 0.25 }}>
          results found
        </Box>
      </Box>

      <Stack flexGrow={1} spacing={1} direction="row" flexWrap="wrap" alignItems="center">
        { filters.status && filters.status !== 'all' && (
          <Block label="Status:">
            <Chip size="small" label={filters.status} onDelete={handleRemoveStatus} />
          </Block>
        )}
        {filters.role && filters.role !== "all" && (
          <Block label="Role:">
            <Chip size="small" label={filters.role} onDelete={() => handleRemoveRole(filters.role)} />
          </Block>
        )}

        {categoryCount > 0 && (
          <Block label="Category:">
            <Chip
              size="small"
              label={`${categoryCount} selected`}
              onDelete={handleRemoveCategory}
            />
          </Block>
        )}

        {(filters?.name?.length || filters?.title?.length) && (
          <Block label="keywords:">
            <Chip size="small" label={filters.name || filters.title}   onDelete={() => handleRemoveName(filters.name ? "name" : filters.title ? "title" : undefined)} />
          </Block>
        )}

        <Button
          color="error"
          onClick={onResetFilters}
          startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
        >
          Clear
        </Button>
      </Stack>
    </Stack>
  );
}

UserTableFiltersResult.propTypes = {
  filters: PropTypes.object,
  onFilters: PropTypes.func,
  onResetFilters: PropTypes.func,
  results: PropTypes.number,
};

// ----------------------------------------------------------------------

function Block({ label, children, sx, ...other }) {
  return (
    <Stack
      component={Paper}
      variant="outlined"
      spacing={1}
      direction="row"
      sx={{
        p: 1,
        borderRadius: 1,
        overflow: 'hidden',
        borderStyle: 'dashed',
        ...sx,
      }}
      {...other}
    >
      <Box component="span" sx={{ typography: 'subtitle2' }}>
        {label}
      </Box>

      <Stack spacing={1} direction="row" flexWrap="wrap">
        {children}
      </Stack>
    </Stack>
  );
}

Block.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  sx: PropTypes.object,
};
